
    var riot = require('riot')
    //src: starling/src/tags/modal-templates.html
riot.tag2('modal-templates',
  '<div class="Modal modal-templates_modal" onclick="{stopPropagation}"> <div class="modal-templates_header"> <header class="Modal_header" style="padding-bottom: 4px;"> <h2 class="Modal_title">Create a new map from a template</h2> <button class="Modal_close" onclick="{dismiss}"> <svg class="Modal_close_icon"> <use xlink:href="#close-icon"></use> </svg> </button> </header> <p class="Modal_description modal-templates_description">Quickly organize your thoughts and ideas with one of many structural templates!</p> <ul class="modal-templates_tags" if="{templateTags.length}"> <li each="{tag in templateTags}" if="{tag}" class="modal-templates_tag"> <button class="Button Button--Pill Button--Faded {\'Button--Active\': tag === parent.currentTag}" onclick="{parent.tagClick}"> {tag} </button> </li> </ul> </div> <div class="modal-templates_body" onwheel="{stopPropagation}"> <div class="modal-templates_wrapper"> <modal-template each="{template in this.templates}" url="{template.url}" canvas="{parent.opts.canvas}" title="{template.title}" description="{template.description}" thumbnail="{template.preview_image_url}" inline="{template.inline}"></modal-template> </div> </div> <loading if="{isLoading}"></loading> </div>',
  '',
  'class="Modal_overlay" style="display: none;" onclick="{dismiss}"', function(opts) {
'use strict';

var _this = this;

var _templates = require('lib/templates');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var canvas = this.opts.canvas;

this.isLoading = true;
this.currentTag = null;
this.templateTags = [];

canvas.templatesModal = this;

this.show = function () {
  if (canvas.searchModal && canvas.searchModal.open) {
    canvas.searchModal.dismiss();
  }
  _this.root.style = '';
};

this.dismiss = function (e) {
  _this.isLoading = false;

  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  _this.root.style = 'display: none;';

  if (window.pageSettings.isTryNow) {
    canvas.onboardingPopupTag.open();
  }
};

this.stopPropagation = function (e) {
  e.stopPropagation();
};

this.on('mount', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return $.ajax('/api/maps/templates');

        case 2:
          _this.templates = _context.sent;

          _this.templateTags = (0, _templates.getAllTags)(_this.templates);

          _this.templates.unshift({
            url: '/maps/new',
            title: 'Blank map',
            preview_image_url: '/images/blank-map-plus.svg'
          });

          _this.allTemplates = [].concat(_this.templates);

          if (window.pageSettings.isTryNow) {
            _this.makeInline();
          }

          _this.isLoading = false;
          _this.update();

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, _this);
})));

this.makeInline = function () {
  _this.templates.forEach(function (t) {
    if (t.title === 'Blank map') {
      t.url = '';
    } else {
      t.url = t.url.replace(/^\/maps/, '/api/maps');
    }
    t.inline = true;
  });
};

this.makeOpenNew = function () {
  _this.templates.forEach(function (t) {
    if (t.title === 'Blank map') {
      t.url = '/maps/new';
    } else {
      t.url = t.url.replace(/^\/api/, '');
    }
    delete t.inline;
  });
};

this.startLoading = function () {
  _this.isLoading = true;
  _this.update();
};

this.tagClick = function (_ref2) {
  var item = _ref2.item;
  var tag = item.tag;

  if (tag === _this.currentTag) {
    _this.currentTag = null;
    _this.templates = [].concat(_this.allTemplates);
    _this.update();

    return false;
  }

  var templateIds = (0, _templates.getTemplatesIdsByTag)(_this.allTemplates, tag);

  _this.currentTag = tag;
  _this.templates = _this.allTemplates.filter(function (_ref3) {
    var template_id = _ref3.template_id;
    return templateIds.includes(template_id);
  });
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-templates')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-templates.html
// module id = 750
// module chunks = 0